export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-dribbble-c18d311192bf02095d7fb6b7a9743f53.svg";